import * as React from 'react';
import styled from 'styled-components';

// Components
import { CheckboxField } from '../../../../../../../../../components/CheckboxField';
import { PlainRenderInputElement } from './PlainRenderInputElement';

// Context
import { RuleEditorContext } from '../../context';

// Enums
import { dtoState } from '../../../../../../../../../common/enums/dtoState';

// Hooks
import { useCriteriaStorePredicate } from '../../../../../../../state/criteria/hooks/useCriteriaStorePredicate';
import { useCriteriaStoreUpdatePredicate } from '../../../../../../../state/criteria/hooks/useCriteriaStoreUpdatePredicate';

// Types
import { ruleEditorViewPartCommonProps } from '../../types';

const BooleanInputContainer = styled.div`
    margin-top: -7px;
`;

export const BooleanInput = ({ id, plainrender = true, ...props }) => {
    const { setEdited } = React.useContext(RuleEditorContext);
    const part = useCriteriaStorePredicate(id);
    const updatePredicateElement = useCriteriaStoreUpdatePredicate();

    if (plainrender) {
        return (
            <PlainRenderInputElement
                value={part?.dataInputBoolean ? 'true' : 'false'}
                overridable={part?.overridable}
            />
        );
    }
    return (
        <BooleanInputContainer>
            <CheckboxField
                id={`part_boolean_${id}`}
                name={`part_boolean_${id}`}
                checked={part?.dataInputBoolean}
                label={''}
                onChange={(event) => {
                    setEdited(true);
                    updatePredicateElement({
                        ...part,
                        dtoState: dtoState.Updated,
                        dataInputBoolean: event.target.checked
                    });
                }}
            />
        </BooleanInputContainer>
    );
};

export default BooleanInput;

BooleanInput.propTypes = {
    ...ruleEditorViewPartCommonProps
};
